export const ALL_REQUEST = "ALL_REQUEST";
export const ALL_SUCCESS = "ALL_SUCCESS";
export const ALL_FAIL = "ALL_FAIL";